import type { RootState } from '@/store';
import type { WarmTransferHandoffContext } from '@/types/warmTransfer';

/** Build handoff context snapshot from current call / case state for warm transfer store. */
export function buildWarmTransferHandoffContext(
  state: Pick<RootState, 'call' | 'case'>,
  options?: { agentNote?: string | null }
): WarmTransferHandoffContext {
  const { call } = state;
  const caseState = state.case;
  const notes = Object.values(call.segmentNotes)
    .flat()
    .map(n => n.note)
    .filter(Boolean)
    .join('\n');
  const transcript = call.transcriptChunks
    .slice(-5)
    .map(c => c.transcript)
    .filter(Boolean)
    .join(' ');

  return {
    customerName: call.callerName,
    customerPhone: call.callerPhoneNumber,
    caseId:
      caseState.currentCase?.id != null
        ? String(caseState.currentCase.id)
        : null,
    caseTitle: caseState.currentCase?.subject ?? null,
    queueName: call.intentName,
    agentNote: options?.agentNote?.trim() || null,
    segmentNotes: notes || null,
    transcriptSummary: transcript || null,
  };
}
